import React from 'react';
import Chat from '../Chat';

export default function SocraticGuideChat() {
  return <Chat inline initiallyOpen guideOnly />;
}
